import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=7191414b&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=7191414b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7191414b",
  null
  
)

export default component.exports